import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

/**
 * StepHeader - A standardized header component for tour planner wizard steps
 * 
 * @param {Object} props
 * @param {string} props.title - The title text to display
 * @returns {JSX.Element} StepHeader component
 */
const StepHeader = ({ title }) => {
  return (
    <div className="d-flex align-items-center">
      <h4 className="mb-0 h6" style={{ color: '#d9d9d9' }}>
        {title}
      </h4>
      <FontAwesomeIcon 
        icon={faInfoCircle} 
        size="sm" 
        className="ms-2 opacity-75" 
        style={{ color: '#d9d9d9' }} 
      />
    </div>
  );
};

export default StepHeader; 